import { HTMLAttributes, PropsWithChildren } from "react";
import styles from "./WarningBanner.module.css";

export type WarningBannerProps = HTMLAttributes<HTMLDivElement>;

export function WarningBanner({
  children,
  ...rest
}: PropsWithChildren<WarningBannerProps>) {
  return (
    <div className={styles.container} {...rest}>
      <div className={styles.accent} />
      {children}
    </div>
  );
}
